export default {
  orsDisaster: {
    aboutTitle: 'Sobre disaster openrouteservice',
  }
}
